export enum PreprintFileSource {
  None = 0,
  Computer,
  Project,
}
